module.exports = __webpack_public_path__ + "static/img/aa1.782806c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202104/aa1.png
// module id = MAup
// module chunks = 0